import * as React from 'react';

export interface ProseProps {
    header: string;
    body: string;
    children?: React.ReactNode;
}

function Prose(props: ProseProps) {
    return (
        <div>
            <h2>{props.header}</h2>
            <p>{props.body}</p>
            {props.children}
        </div>
    );
}
export default Prose;
